import { render, staticRenderFns } from "./ProductBenefits.vue?vue&type=template&id=198ac0e2&scoped=true&"
import script from "./ProductBenefits.vue?vue&type=script&lang=js&"
export * from "./ProductBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ac0e2",
  null
  
)

export default component.exports